/* IC — "Reveal your fate": code + email entry, then the role and reward reveal.
   Talks to the Google Apps Script endpoint set in the section settings.
   With no endpoint set, it runs in demo mode using the sample codes in the section. */
if (!customElements.get('ich-fate')) {
  class IchFate extends HTMLElement {
    connectedCallback() {
      const $ = (s) => this.querySelector(s);
      this.cfg = JSON.parse($('[data-fate-config]').textContent);
      this.form = $('[data-fate-form]');
      this.code = $('[data-fate-code]');
      this.codeField = $('[data-fate-code-field]');
      this.email = $('[data-fate-email]');
      this.optin = $('[data-fate-optin]');
      this.submit = $('[data-fate-submit]');
      this.err = $('[data-fate-error]');
      this.entry = $('[data-fate-entry]');
      this.seal = $('[data-fate-seal]');
      this.reveal = $('[data-fate-reveal]');
      this.card = $('[data-fate-card]');
      this.prize = $('[data-fate-prize]');
      this.glory = $('[data-fate-glory]');
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.buildEmbers();
      this.formatAsTyped();
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      const again = $('[data-fate-again]');
      if (again) again.addEventListener('click', () => this.reset());
      const copy = $('[data-fate-copy]');
      if (copy) copy.addEventListener('click', () => this.copyCode(copy));
    }

    buildEmbers() {
      const box = this.querySelector('[data-fate-embers]');
      if (!box || this.reduce) return;
      for (let i = 0; i < 24; i++) {
        const e = document.createElement('i');
        e.className = 'ich-fate__ember';
        e.style.left = (Math.random() * 100) + '%';
        e.style.animationDuration = (7 + Math.random() * 9) + 's';
        e.style.animationDelay = (-Math.random() * 12) + 's';
        e.style.setProperty('--drift', (Math.random() * 90 - 45) + 'px');
        box.appendChild(e);
      }
    }

    /* keep the code tidy while it is typed: PREFIX-XXXX-XXXX */
    formatAsTyped() {
      const prefix = (this.cfg.prefix || '').toUpperCase();
      this.code.addEventListener('input', () => {
        let v = this.code.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (prefix && v.indexOf(prefix) === 0) v = v.slice(prefix.length);
        v = v.slice(0, 8);
        let out = (prefix ? prefix + (v ? '-' : '') : '') + v.slice(0, 4);
        if (v.length > 4) out += '-' + v.slice(4);
        this.code.value = out;
        this.codeField.classList.remove('is-wrong');
        this.err.textContent = '';
      });
    }

    fail(msg, onEmail) {
      this.err.textContent = msg;
      if (onEmail) { this.email.focus(); }
      else { this.codeField.classList.add('is-wrong'); this.code.focus(); }
    }

    busy(on) {
      this.submit.classList.toggle('is-busy', on);
      this.submit.disabled = on;
      this.code.disabled = on;
      this.email.disabled = on;
    }

    onSubmit(e) {
      e.preventDefault();
      const code = this.code.value.trim().toUpperCase();
      const mail = this.email.value.trim();
      const bare = code.replace(/[^A-Z0-9]/g, '');

      if (bare.length < (this.cfg.minLength || 8)) return this.fail(this.cfg.errShort);
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) return this.fail(this.cfg.errEmail, true);

      this.busy(true);
      this.lookup(code, mail, this.optin ? this.optin.checked : false)
        .then((res) => {
          if (!res || !res.ok) {
            this.busy(false);
            var map = { busy: this.cfg.errBusy, server: this.cfg.errServer, forbidden: this.cfg.errServer,
                        bad_email: this.cfg.errEmail, no_code: this.cfg.errShort };
            this.fail(map[res && res.error] || this.cfg.errNotFound, res && res.error === 'bad_email');
            return;
          }
          this.play(res, mail);
        })
        .catch(() => { this.busy(false); this.fail(this.cfg.errNetwork); });
    }

    lookup(code, email, optin) {
      // Demo mode: answer from the sample codes in the section settings.
      if (!this.cfg.endpoint) {
        const found = (this.cfg.samples || {})[code.replace(/[^A-Z0-9]/g, '')];
        return new Promise((res) => setTimeout(() => res(found ? Object.assign({ ok: true }, found) : null), 800));
      }
      // Content-Type text/plain keeps this a "simple" request, so the browser
      // sends it straight through without a preflight Apps Script can't answer.
      return fetch(this.cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ code: code, email: email, optin: optin, secret: this.cfg.secret || '' })
      })
        .then((r) => r.text())
        .then((text) => {
          try {
            return JSON.parse(text);
          } catch (err) {
            // Apps Script answers with an HTML page when the script itself throws —
            // usually "Missing tab: Codes" (setUp not run) or a deployment set to
            // anything other than "Anyone". Surface it rather than hiding it.
            var hint = (text.match(/Error: ([^<]{0,160})/) || [])[1];
            console.error('[fate] endpoint did not return JSON.' + (hint ? ' ' + hint : ''), text.slice(0, 300));
            return { ok: false, error: 'server', hint: hint || '' };
          }
        });
    }

    play(res, mail) {
      const roles = this.cfg.roles || {};
      const role = roles[res.role] || roles.innocent || { name: '', line: '', mark: '' };

      this.querySelector('[data-fate-mark]').innerHTML = role.mark || '';
      this.querySelector('[data-fate-role-name]').textContent = role.name || '';
      this.querySelector('[data-fate-role-line]').textContent = role.line || '';
      const stamp = this.querySelector('[data-fate-stamp]');
      stamp.innerHTML = res.used
        ? '<span class="ich-fate__stamp">' + (this.cfg.usedLabel || 'Already opened') +
          (res.usedOn ? ' ' + res.usedOn : '') + '</span>'
        : '';
      this.card.className = 'ich-fate__card ' + (res.role || 'innocent');

      const p = res.prize || {};
      this.querySelector('[data-fate-prize-title]').textContent = p.title || '';
      this.querySelector('[data-fate-prize-note]').textContent = p.note || '';

      const chip = this.querySelector('[data-fate-chip]');
      if (p.code) { chip.hidden = false; this.querySelector('[data-fate-prize-code]').textContent = p.code; }
      else { chip.hidden = true; }

      const cta = this.querySelector('[data-fate-cta]');
      if (p.cta && p.href) { cta.hidden = false; cta.textContent = p.cta; cta.href = p.href; }
      else { cta.hidden = true; }

      const t = this.reduce ? 0 : 1;
      this.seal.classList.add('is-opening');
      setTimeout(() => {
        this.entry.style.transition = 'opacity .5s ease';
        this.entry.style.opacity = '0';
        setTimeout(() => {
          this.entry.hidden = true;
          this.reveal.classList.add('is-on');
          setTimeout(() => this.card.classList.add('is-flipped'), 60 * t + 40);
          setTimeout(() => this.prize.classList.add('is-on'), 950 * t + 120);
          if (res.role === 'chosen') setTimeout(() => this.celebrate(), 1150 * t + 160);
        }, 480 * t);
      }, 760 * t);
    }

    celebrate() {
      if (!this.glory) return;
      if (!this.reduce) {
        for (let i = 0; i < 60; i++) {
          const s = document.createElement('i');
          s.style.left = (50 + (Math.random() * 34 - 17)) + '%';
          s.style.top = (48 + (Math.random() * 20 - 10)) + '%';
          s.style.setProperty('--dx', (Math.random() * 620 - 310) + 'px');
          s.style.setProperty('--dy', (Math.random() * -460 - 90) + 'px');
          s.style.animationDelay = (Math.random() * .7) + 's';
          s.style.background = Math.random() > .45 ? '#E4CE92' : '#C8A24A';
          this.glory.appendChild(s);
        }
      }
      this.glory.classList.add('is-on');
    }

    copyCode(btn) {
      const text = this.querySelector('[data-fate-prize-code]').textContent;
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(() => {
        const was = btn.textContent;
        btn.textContent = this.cfg.copied || 'Copied';
        setTimeout(() => { btn.textContent = was; }, 1600);
      });
    }

    reset() {
      if (this.glory) {
        this.glory.classList.remove('is-on');
        this.glory.querySelectorAll('i').forEach((s) => s.remove());
      }
      this.reveal.classList.remove('is-on');
      this.card.classList.remove('is-flipped');
      this.prize.classList.remove('is-on');
      setTimeout(() => {
        this.seal.classList.remove('is-opening');
        this.entry.hidden = false;
        requestAnimationFrame(() => { this.entry.style.opacity = '1'; });
        this.busy(false);
        this.code.value = '';
        this.err.textContent = '';
        this.code.focus();
      }, 420);
    }
  }
  customElements.define('ich-fate', IchFate);
}
